'use client';

import { PageLoading } from '@/ui';
import { defaultPathForUser } from '@/lib/session';
import { useAuthRedirect } from '@/providers/app-runtime';

export default function HomePage() {
  useAuthRedirect({
    whenUnauthenticated: '/login',
    whenAuthenticated: defaultPathForUser,
  });

  return (
    <div className="grid min-h-screen place-items-center bg-zinc-950">
      <PageLoading />
    </div>
  );
}
